import React from 'react'
import './Subtotal.css'
import { useStateValue } from './StateProvider';
import CurrencyFormat from 'react-currency-format';
import { useEffect } from 'react';
import { getBasketTotal } from './reducer';

function SubtotalReceipt({total, items}) {
    const [{ basket, deliveryfees }, dispatch] = useStateValue();

    useEffect(() => {
        if(getBasketTotal(basket) < 50){
            document.getElementById("006").style.display = "flex"; 
        } else{
            document.getElementById("006").style.display = "none";
        }
    }, [basket])

    return (
        <div className="subtotal">
            <div className="subtotal__left">
                <div id='006' className='subtotal__deliverystatus'>
                    <label >{deliveryfees}$ Delivery Fees </label> 
                </div>
            </div>
            <div className="subtotal__right">
                <div className="subtotal__up">
                    <strong>Subtotal </strong>
                    <small> ({items} items)</small>
                </div>
                <div className="subtotal__down">
                    <CurrencyFormat
                        renderText={(value) => (
                            <>
                                <strong>{value}</strong>
                            </>
                        )}
                        decimalScale={2}
                        value={total}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                    />
                </div>
            </div>
        </div>
    )
}

export default SubtotalReceipt;